
import ArrowUp from '@/assets/icons/fontawesome/light/arrow-up.svg?inline'

export default {
  components: {
    ArrowUp,
  },
  props: {
    facilities: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expanded: false,
    }
  },
}
